'use client';

import { useTranslations } from 'next-intl';
import { Currency } from 'utils/Currency';
import { ClueShopifyMap } from 'content/products/addons/clue';
import { CurrencySymbol, useFormatPrice } from 'hooks/pricing/useFormattedPrice';
import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import { useCartStore, useShallow } from 'components/shared/Cart';
import { CustomImage } from '../custom-image';
import {
  ImageContainer,
  InfoModalContainer,
  InfoModalDescription,
  InfoModalTitle,
  PricingModal,
} from './layout';

export const ClueCartModal = () => {
  const t = useTranslations('ring');
  const CartClient = useCartStore(
    useShallow((s) => ({ store: s.store, currency: s.currency })),
  );
  const formatPriceWithComma = useFormatPrice();

  const { store, currency } = CartClient;
  const CurrencyCode = CurrencySymbol[currency ?? Currency.usd];

  return (
    <InfoModalContainer>
      <InfoModalTitle>
        <h3>{t('ring.infoModals.clue.title')}</h3>
        <p>
          {t('ring.infoModals.clue.subtitle.a')}
          <>
            {CurrencyCode}
            {formatPriceWithComma(
              ClueShopifyMap[store as ShopifyStore].Year1.discountedPrice,
            )}
          </>
          {t('ring.infoModals.clue.subtitle.b')}
          <>
            {CurrencyCode}
            {formatPriceWithComma(
              ClueShopifyMap[store as ShopifyStore].Year1.price,
            )}
          </>
          {t('ring.infoModals.clue.subtitle.c')}
        </p>
        <ImageContainer className="clue-container">
          <CustomImage
            src={`web_v2/cart-info-modals/clue-1-square.png`}
            width={1388}
            height={1133}
            alt={t('ring.infoModals.clue.imageAlt')}
            priority
          />
        </ImageContainer>
      </InfoModalTitle>
      <InfoModalDescription>
        <p>{t('ring.infoModals.clue.description')}</p>
      </InfoModalDescription>
      <InfoModalDescription>
        <h3>{t('ring.infoModals.clue.text.a.title')}</h3>

        <ul>
          <li>
            <p>{t('ring.infoModals.clue.text.a.li1')}</p>
          </li>
          <li>
            <p>{t('ring.infoModals.clue.text.a.li2')}</p>
          </li>
          <li>
            <p>{t('ring.infoModals.clue.text.a.li3')}</p>
          </li>
        </ul>
      </InfoModalDescription>
      <InfoModalDescription>
        <h3>{t('ring.infoModals.clue.text.b.title')}</h3>

        <ul>
          <li>
            <p>{t('ring.infoModals.clue.text.b.li1')}</p>
          </li>
          <li>
            <p>{t('ring.infoModals.clue.text.b.li2')}</p>
          </li>
          <li>
            <p>{t('ring.infoModals.clue.text.b.li3')}</p>
          </li>
        </ul>
      </InfoModalDescription>

      <ImageContainer className="screen">
        <CustomImage
          src="web_v2/cart-info-modals/clue-2.png"
          width={1388}
          height={798}
          alt={t('ring.infoModals.clue.secondaryAlt')}
          priority
        />
      </ImageContainer>
    </InfoModalContainer>
  );
};

export const CluePricingModal = () => (
  <PricingModal>
    <ClueCartModal />
  </PricingModal>
);
